// Import necessary utility functions if any (e.g., generateColor, scaleByPixelRatio)
// For now, assuming they will be passed or accessed via a shared state/config if needed from main.js

export function pointerPrototype() {
  this.id = -1;
  this.texcoordX = 0;
  this.texcoordY = 0;
  this.prevTexcoordX = 0;
  this.prevTexcoordY = 0;
  this.deltaX = 0;
  this.deltaY = 0;
  this.down = false;
  this.moved = false;
  this.color = [0, 0, 0]; // Initial color, might be updated from main.js
}

export function updatePointerDownData(
  pointer,
  id,
  posX,
  posY,
  canvas,
  generateColorFunc
) {
  pointer.id = id;
  pointer.down = true;
  pointer.moved = false;
  pointer.texcoordX = posX / canvas.width;
  pointer.texcoordY = 1.0 - posY / canvas.height;
  pointer.prevTexcoordX = pointer.texcoordX;
  pointer.prevTexcoordY = pointer.texcoordY;
  pointer.deltaX = 0;
  pointer.deltaY = 0;
  pointer.color = generateColorFunc();
}

export function updatePointerMoveData(pointer, posX, posY, canvas, color) {
  // Pass canvas for dimensions
  pointer.prevTexcoordX = pointer.texcoordX;
  pointer.prevTexcoordY = pointer.texcoordY;
  pointer.texcoordX = posX / canvas.width;
  pointer.texcoordY = 1.0 - posY / canvas.height;
  pointer.deltaX = correctDeltaX(
    pointer.texcoordX - pointer.prevTexcoordX,
    canvas
  );
  pointer.deltaY = correctDeltaY(
    pointer.texcoordY - pointer.prevTexcoordY,
    canvas
  );
  pointer.moved = Math.abs(pointer.deltaX) > 0 || Math.abs(pointer.deltaY) > 0;
  if (color) {
    // color might be null if not provided (e.g. during initial move)
    pointer.color = color;
  }
}

export function updatePointerUpData(pointer) {
  pointer.down = false;
}

export function correctDeltaX(delta, canvas) {
  // Pass canvas for dimensions
  let aspectRatio = canvas.width / canvas.height;
  if (aspectRatio < 1) delta *= aspectRatio;
  return delta;
}

export function correctDeltaY(delta, canvas) {
  // Pass canvas for dimensions
  let aspectRatio = canvas.width / canvas.height;
  if (aspectRatio > 1) delta /= aspectRatio;
  return delta;
}
